import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { ApiService } from './api.service';

@Injectable()
export class ModelService {

  constructor(
    private apiService: ApiService,
  ) {
  }

  ItemTypeUrlMapping:any = {
    CU: "companies",
    CO: "contacts",
    LD: "leads",
    DL: "deals",
    CS: "cases",
    EM: "emails",
    CA: "calls",
    ME: "meetings",
    TA: "tasks",
    FL: "files"
  }

  ModelUrlMapping:any = {
    company: "companies",
    contact: "contacts",
    lead: "leads",
    deal: "deals",
    case: "cases",
    email: "emails",
    call: "calls",
    meeting: "meetings",
    task: "tasks",
    file: "files"
  }

  loadRelatedFiles(related_type, related_ID): Observable<any> {
    var model = related_type;
    return this.apiService.get(`/models/${model}/${related_ID}/file`).map(
      result => {
        return result;
      }
    )
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/model.service.ts